import { render, staticRenderFns } from "./DogTaskManage.vue?vue&type=template&id=3042f8ad&scoped=true"
import script from "./DogTaskManage.vue?vue&type=script&lang=js"
export * from "./DogTaskManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3042f8ad",
  null
  
)

export default component.exports